class Elementor_Image_Box{
    static instance;

    static getInstance() {
        if (!Elementor_Image_Box.instance) {
            Elementor_Image_Box.instance = new Elementor_Image_Box();
        }
        return Elementor_Image_Box.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/image-box.default', ( $scope ) => {
            setTimeout(() => {
                let $object = $scope.find('object');
                if($object.length > 0){
                    let a = $object.get(0);
                    let svgDoc = a.contentDocument;
                    $object.after($(svgDoc).find('svg'));
                    $object.remove();
                }
            }, 200);
        } );
    }
}


Elementor_Image_Box.getInstance();